import { decryptData, encryptData } from "./criptografia";

const pareceCifrado = (valor: string) => /^[0-9a-fA-F]+$/.test(valor.trim());

export async function getItemStorage(key: string): Promise<string | null> {
  const storedValue = sessionStorage.getItem(key);
  if (!storedValue) {
    return null;
  }

  // setItemStorage grava em texto puro: descriptografar sempre falharia e devolveria null,
  // apagando a sessao a cada recarregamento no meio do cadastro.
  if (!pareceCifrado(storedValue)) {
    return storedValue;
  }

  try {
    return await decryptData(storedValue);
  } catch (error) {
    console.error("Erro ao descriptografar os dados:", error);
    return null;
  }
}

export function setItemStorage(key: string, value: string): void {
  if (!key) throw new Error("Chave ou valor inválido(s).");
  if (!value) {
    removeItemStorage(key);
    return;
  }

  sessionStorage.setItem(key, value);

  //   encryptData(value)
  //     .then((encryptedValue) => {
  //       sessionStorage.setItem(key, encryptedValue);
  //     })
  //     .catch((error) => {
  //       console.error("Erro ao criptografar os dados:", error);
  //     });
}
export function removeItemStorage(key: string) {
  return sessionStorage.removeItem(key);
}

// usado para edição dos dados

export function getLocalStorage(key: string): string | null {
  return sessionStorage.getItem(key);
}

export function setItemLocalStorage(key: string, value: string): void {
  sessionStorage.setItem(key, value);
}
export function removeLocalStorage(key: string) {
  return sessionStorage.removeItem(key);
}
